import { userSchema } from '@billing/validation/user';
import { z } from 'zod';

export type User = z.infer<typeof userSchema>;

export type FormUser = Omit<User, 'id'>;

export const isUser = (obj: any): obj is User => {
  return userSchema.safeParse(obj).success;
};
